import type { FieldDef } from '../types'

export function serializeFieldValue(field: FieldDef, val: unknown): unknown {
  switch (field.type) {
    case 'text':
    case 'cron': {
      const trimmed = String(val ?? '').trim()
      if (field.required === false && trimmed === '') {
        return null
      }
      return trimmed
    }
    case 'select': {
      const trimmed = String(val ?? '').trim()
      if (field.required === false && trimmed === '') {
        return null
      }
      if (field.valueType === 'number') {
        return Number(trimmed)
      }
      return trimmed
    }
    case 'number': {
      return Number(val)
    }
    case 'checkbox': {
      return val
    }
  }
}
